import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a8dac1cc")

_pushScopeId("data-v-a8dac1cc")
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "image" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("td", _hoisted_1, [
    _createVNode("figure", _hoisted_2, [
      _createVNode("img", {
        class: "is-rounded",
        src: _ctx.user.picture,
        alt: ""
      }, null, 8, ["src"])
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.user.picture ? 'span' : 'strong'), null, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
      ]),
      _: 1
    }))
  ]))
})